module.exports = __webpack_public_path__ + "static/media/arrow-circle.d06ac0dc.svg";